import { render } from "./InstructorsPage.vue?vue&type=template&id=4202ea1a&scoped=true"
import script from "./InstructorsPage.vue?vue&type=script&lang=js"
export * from "./InstructorsPage.vue?vue&type=script&lang=js"

import "./InstructorsPage.vue?vue&type=style&index=0&id=4202ea1a&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4202ea1a"]])

export default __exports__